import './templates';

import  * as components  from './components';

window.AngularEcommerce = window.AngularEcommerce || {};
window.AngularEcommerce['freshen'] = {
    ...components
};
